// extracted by mini-css-extract-plugin
export default {"container":"loading-dots-center-module--container--01a7c"};